module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.5646",
      "hs-test-utils": "static-1.8238",
      "I18n": "static-7.1651",
      "jasmine-runner": "static-1.6665",
      "quartz": "static-1.7316",
      "hubspot-url-utils": "static-1.4284",
      "outpost": "static-1.4376",
      "PatternValidationJS": "static-1.3110",
      "react": "static-7.190",
      "moment": "static-3.26",
      "foundations-components": "static-1.8326",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3349",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.75",
      "redux": "static-4.16",
      "testing-library": "static-1.155",
      "enviro": "static-4.477",
      "i18n-data": "static-1.225",
      "metrics-js": "static-1.9851",
      "moment-timezone": "static-5.86",
      "react-utils": "static-2.5488",
      "StyleGuideUI": "static-3.491",
      "jasmine": "static-4.4534",
      "quartz-config": "static-1.1094",
      "webpack-env": "static-1.54",
      "quartz-core": "static-1.6535",
      "csstype": "static-1.50",
      "bend-plugin-foundations-components": "static-1.4595",
      "floating-ui": "static-1.60",
      "foundations-assets": "static-1.5087",
      "foundations-theming": "static-1.4660",
      "foundations-theming-specialty": "static-1.2376",
      "hs-story-utils": "static-1.9637",
      "react-aria": "static-1.69",
      "react-create-root-preference": "static-1.51",
      "react-select-plus": "static-1.108",
      "react-virtualized": "static-2.102",
      "styled-components": "static-2.94",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2366",
      "ui-fonts": "static-1.948",
      "ui-images": "static-2.1215",
      "bender-build-tools": "static-1.3336",
      "hoist-non-react-statics": "static-3.9",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "HeadJS": "static-2.782",
      "hub-http": "static-1.6429",
      "hub-http-janus": "static-1.859",
      "hubspotter-http": "static-1.4798",
      "icons": "static-2.668",
      "mobile-manifest-mixins": "static-1.556",
      "module-federation": "static-1.29",
      "PortalIdParser": "static-2.426",
      "quartz-auth": "static-1.991",
      "quartz-head": "static-1.981",
      "quartz-i18n": "static-1.991",
      "quartz-routing": "static-1.746",
      "quartz-test": "static-1.991",
      "quartz-tracking": "static-1.695",
      "quick-fetch": "static-1.4064",
      "raven": "static-3.6143",
      "raven-hubspot": "static-1.6450",
      "react-rhumb": "static-1.16915",
      "trellis-components": "static-1.2385",
      "UIComponents": "static-3.8632",
      "usage-tracker-container": "static-1.7556",
      "usage-tracker-core": "static-1.7416",
      "bend-plugin-foundations-theming": "static-1.3143",
      "foundations-theming-base": "static-1.3645",
      "stylex": "static-1.37",
      "classnames": "static-2.10",
      "react-input-autosize": "static-2.17",
      "hs-locale-management": "static-1.227",
      "sassPrefix": "static-1.160",
      "hub-http-shared-msw-handlers": "static-1.10467",
      "hubspotter-http-shared-msw-handlers": "static-1.10465",
      "hs-promise-rejection-tracking": "static-1.5800",
      "usage-tracker-session-replay": "static-1.5252",
      "web-vitals": "static-1.9",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "trellis-theming": "static-1.1167",
      "tanstack-virtual": "static-1.35",
      "cssUtils": "static-1.856",
      "head-dlb": "static-1.5007",
      "HubStyle": "static-2.11993",
      "HubStyleTokens": "static-2.11686",
      "ts-schema": "static-1.4227",
      "amplitude-session-replay-browser": "static-1.60"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.5646",
      "hs-test-utils": "/hs-test-utils/static-1.8238",
      "I18n": "/I18n/static-7.1651",
      "jasmine-runner": "/jasmine-runner/static-1.6665",
      "quartz": "/quartz/static-1.7316",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4284",
      "outpost": "/outpost/static-1.4376",
      "PatternValidationJS": "/PatternValidationJS/static-1.3110",
      "react": "/react/static-7.190",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.8326",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3349",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.75",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.155",
      "enviro": "/enviro/static-4.477",
      "i18n-data": "/i18n-data/static-1.225",
      "metrics-js": "/metrics-js/static-1.9851",
      "moment-timezone": "/moment-timezone/static-5.86",
      "react-utils": "/react-utils/static-2.5488",
      "StyleGuideUI": "/StyleGuideUI/static-3.491",
      "jasmine": "/jasmine/static-4.4534",
      "quartz-config": "/quartz-config/static-1.1094",
      "webpack-env": "/webpack-env/static-1.54",
      "quartz-core": "/quartz-core/static-1.6535",
      "csstype": "/csstype/static-1.50",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4595",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-assets": "/foundations-assets/static-1.5087",
      "foundations-theming": "/foundations-theming/static-1.4660",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2376",
      "hs-story-utils": "/hs-story-utils/static-1.9637",
      "react-aria": "/react-aria/static-1.69",
      "react-create-root-preference": "/react-create-root-preference/static-1.51",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-virtualized": "/react-virtualized/static-2.102",
      "styled-components": "/styled-components/static-2.94",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2366",
      "ui-fonts": "/ui-fonts/static-1.948",
      "ui-images": "/ui-images/static-2.1215",
      "bender-build-tools": "/bender-build-tools/static-1.3336",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.782",
      "hub-http": "/hub-http/static-1.6429",
      "hub-http-janus": "/hub-http-janus/static-1.859",
      "hubspotter-http": "/hubspotter-http/static-1.4798",
      "icons": "/icons/static-2.668",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
      "module-federation": "/module-federation/static-1.29",
      "PortalIdParser": "/PortalIdParser/static-2.426",
      "quartz-auth": "/quartz-auth/static-1.991",
      "quartz-head": "/quartz-head/static-1.981",
      "quartz-i18n": "/quartz-i18n/static-1.991",
      "quartz-routing": "/quartz-routing/static-1.746",
      "quartz-test": "/quartz-test/static-1.991",
      "quartz-tracking": "/quartz-tracking/static-1.695",
      "quick-fetch": "/quick-fetch/static-1.4064",
      "raven": "/raven/static-3.6143",
      "raven-hubspot": "/raven-hubspot/static-1.6450",
      "react-rhumb": "/react-rhumb/static-1.16915",
      "trellis-components": "/trellis-components/static-1.2385",
      "UIComponents": "/UIComponents/static-3.8632",
      "usage-tracker-container": "/usage-tracker-container/static-1.7556",
      "usage-tracker-core": "/usage-tracker-core/static-1.7416",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3143",
      "foundations-theming-base": "/foundations-theming-base/static-1.3645",
      "stylex": "/stylex/static-1.37",
      "classnames": "/classnames/static-2.10",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-locale-management": "/hs-locale-management/static-1.227",
      "sassPrefix": "/sassPrefix/static-1.160",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10467",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10465",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5800",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5252",
      "web-vitals": "/web-vitals/static-1.9",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "trellis-theming": "/trellis-theming/static-1.1167",
      "tanstack-virtual": "/tanstack-virtual/static-1.35",
      "cssUtils": "/cssUtils/static-1.856",
      "head-dlb": "/head-dlb/static-1.5007",
      "HubStyle": "/HubStyle/static-2.11993",
      "HubStyleTokens": "/HubStyleTokens/static-2.11686",
      "ts-schema": "/ts-schema/static-1.4227",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
    },
    "bundlingPackage": "feedback-knowledge-js",
    "bundlingPackageVersion": "static-1.5646",
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};